<template>
  <v-container v-if="fund && formData && fund.state !== 'NEW'">
    <v-app-bar app dark dense color="secondary">
      <v-toolbar-title>
        {{ formData.name }}
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn
        :to="{
          name: 'auditAuditPeriod',
          params: { id: fund.auditPeriod.id },
        }"
      >
        {{ $t("auditor.stepModelRequirements.back") }}
      </v-btn>
    </v-app-bar>

    <v-form ref="form" v-model="valid">
      <div class="pa-1">
        <v-card>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="formData.name"
                  :label="$t('fundBaseForm.name.label')"
                  :rules="[(v) => !!v || $t('validation.required')]"
                  required
                >
                  <template #prepend>
                    <v-tooltip bottom max-width="300">
                      <template #activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help</v-icon>
                      </template>
                      <span>{{ $t("fundBaseForm.name.help") }}</span>
                    </v-tooltip>
                  </template>
                </v-text-field>

                <v-select
                  v-model="formData.assetManagement"
                  :items="assetManagement"
                  :label="$t('fundBaseForm.assetManagement.label')"
                >
                  <template #prepend>
                    <v-tooltip bottom max-width="300">
                      <template #activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help</v-icon>
                      </template>
                      <span>{{ $t("fundBaseForm.assetManagement.help") }}</span>
                    </v-tooltip>
                  </template>
                </v-select>

                <v-select :items="fof" v-model="formData.fof" :label="$t('fundBaseForm.fof.label')">
                  <template #prepend>
                    <v-tooltip bottom max-width="300">
                      <template #activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help</v-icon>
                      </template>
                      <span>{{ $t("fundBaseForm.fof.help") }}</span>
                    </v-tooltip>
                  </template>
                </v-select>

                <v-autocomplete
                  v-model="formData.assetClasses"
                  :items="assetClasses"
                  :label="$t('fundBaseForm.assetClasses.label')"
                  :rules="[(v) => v.length > 0 || $t('validation.required')]"
                  multiple
                  small-chips
                  deletable-chips
                >
                  <template #prepend>
                    <v-tooltip bottom max-width="300">
                      <template #activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help</v-icon>
                      </template>
                      <span>{{ $t("fundBaseForm.assetClasses.help") }}</span>
                    </v-tooltip>
                  </template>
                </v-autocomplete>

                <v-text-field
                  v-model="formData.assetClassesComment"
                  :label="$t('fundBaseForm.assetClassesComment.label')"
                  required
                >
                  <template #prepend>
                    <v-tooltip bottom max-width="300">
                      <template #activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help</v-icon>
                      </template>
                      <span>{{ $t("fundBaseForm.assetClassesComment.help") }}</span>
                    </v-tooltip>
                  </template>
                </v-text-field>

                <v-text-field v-model="formData.assetManager" :label="$t('fundBaseForm.assetManager.label')" required>
                  <template #prepend>
                    <v-tooltip bottom max-width="300">
                      <template #activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help</v-icon>
                      </template>
                      <span>{{ $t("fundBaseForm.assetManager.help") }}</span>
                    </v-tooltip>
                  </template>
                </v-text-field>

                <v-text-field v-model="formData.dependance" :label="$t('fundBaseForm.dependance.label')" required>
                  <template #prepend>
                    <v-tooltip bottom max-width="300">
                      <template #activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help</v-icon>
                      </template>
                      <span>{{ $t("fundBaseForm.dependance.help") }}</span>
                    </v-tooltip>
                  </template>
                </v-text-field>

                <v-combobox
                  v-model="formData.isins"
                  :label="$t('fundBaseForm.isins.label')"
                  :hint="$t('fundBaseForm.isins.hint')"
                  :rules="[(v) => v.length > 0 || $t('validation.required')]"
                  multiple
                  small-chips
                  clearable
                  deletable-chips
                >
                  <template #prepend>
                    <v-tooltip bottom max-width="300">
                      <template #activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help</v-icon>
                      </template>
                      <span>{{ $t("fundBaseForm.isins.help") }}</span>
                    </v-tooltip>
                  </template>
                </v-combobox>

                <v-text-field v-model="formData.benchmark" :label="$t('fundBaseForm.benchmark.label')" required>
                  <template #prepend>
                    <v-tooltip bottom max-width="300">
                      <template #activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help</v-icon>
                      </template>
                      <span>{{ $t("fundBaseForm.benchmark.help") }}</span>
                    </v-tooltip>
                  </template>
                </v-text-field>

                <div>
                  <v-autocomplete
                    v-model="formData.investmentApproaches"
                    :items="investmentApproaches"
                    :label="$t('fundBaseForm.investmentApproaches.label')"
                    :rules="[(v) => v.length > 0 || $t('validation.required')]"
                    multiple
                    small-chips
                    deletable-chips
                  >
                    <template #prepend>
                      <v-tooltip bottom max-width="300">
                        <template #activator="{ on }">
                          <v-icon color="primary" dark v-on="on">mdi-help</v-icon>
                        </template>
                        <span>{{ $t("fundBaseForm.investmentApproaches.help") }}</span>
                      </v-tooltip>
                    </template>
                  </v-autocomplete>
                </div>

                <v-select
                  :items="fundTypes"
                  :label="$t('fundBaseForm.fundType.label')"
                  v-model="formData.fundType"
                  :rules="[(v) => !!v || $t('validation.required')]"
                >
                  <template #prepend>
                    <v-tooltip bottom max-width="300">
                      <template #activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help</v-icon>
                      </template>
                      <span>{{ $t("fundBaseForm.fundType.help") }}</span>
                    </v-tooltip>
                  </template>
                </v-select>

                <v-checkbox v-model="formData.privateInvestors" :label="$t('fundBaseForm.privateInvestors.label')">
                  <template #prepend>
                    <v-tooltip bottom max-width="300">
                      <template #activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help</v-icon>
                      </template>
                      <span>{{ $t("fundBaseForm.privateInvestors.help") }}</span>
                    </v-tooltip>
                  </template>
                </v-checkbox>

                <v-autocomplete
                  v-model="formData.tranches"
                  :items="tranches"
                  :label="$t('fundBaseForm.tranches.label')"
                  multiple
                  small-chips
                  deletable-chips
                >
                  <template #prepend>
                    <v-tooltip bottom max-width="300">
                      <template #activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help</v-icon>
                      </template>
                      <span>{{ $t("fundBaseForm.tranches.help") }}</span>
                    </v-tooltip>
                  </template>
                </v-autocomplete>

                <v-text-field
                  v-model="formData.tranchesComment"
                  :label="$t('fundBaseForm.tranchesComment.label')"
                  required
                >
                  <template #prepend>
                    <v-tooltip bottom max-width="300">
                      <template #activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help</v-icon>
                      </template>
                      <span>{{ $t("fundBaseForm.tranchesComment.help") }}</span>
                    </v-tooltip>
                  </template>
                </v-text-field>

                <v-checkbox v-model="formData.performanceFee" :label="$t('fundBaseForm.performanceFee.label')">
                  <template #prepend>
                    <v-tooltip bottom max-width="300">
                      <template #activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help</v-icon>
                      </template>
                      <span>{{ $t("fundBaseForm.performanceFee.help") }}</span>
                    </v-tooltip>
                  </template>
                </v-checkbox>

                <v-checkbox v-model="formData.rter" :label="$t('fundBaseForm.rter.label')">
                  <template #prepend>
                    <v-tooltip bottom max-width="300">
                      <template #activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help</v-icon>
                      </template>
                      <span>{{ $t("fundBaseForm.rter.help") }}</span>
                    </v-tooltip>
                  </template>
                </v-checkbox>
              </v-col>

              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="formData.salesCountries"
                  :items="countries"
                  :label="$t('fundBaseForm.salesCountries.label')"
                  :hint="$t('fundBaseForm.salesCountries.hint')"
                  persistent-hint
                  :rules="[(v) => v.length > 0 || $t('validation.required')]"
                  multiple
                  small-chips
                  deletable-chips
                >
                  <template #prepend>
                    <v-tooltip bottom max-width="300">
                      <template #activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help</v-icon>
                      </template>
                      <span>{{ $t("fundBaseForm.salesCountries.help") }}</span>
                    </v-tooltip>
                  </template>
                </v-autocomplete>

                <v-select
                  :items="investmentRegions"
                  :label="$t('fundBaseForm.investmentRegion.label')"
                  :rules="[(v) => !!v || $t('validation.required')]"
                  v-model="formData.investmentRegion"
                >
                  <template #prepend>
                    <v-tooltip bottom max-width="300">
                      <template #activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help</v-icon>
                      </template>
                      <span>{{ $t("fundBaseForm.investmentRegion.help") }}</span>
                    </v-tooltip>
                  </template>
                </v-select>

                <v-text-field
                  :items="investmentRegions"
                  v-model="formData.investmentRegionComment"
                  :label="$t('fundBaseForm.investmentRegionComment.label')"
                  required
                >
                  <template #prepend>
                    <v-tooltip bottom max-width="300">
                      <template #activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help</v-icon>
                      </template>
                      <span>{{ $t("fundBaseForm.investmentRegionComment.help") }}</span>
                    </v-tooltip>
                  </template>
                </v-text-field>

                <v-text-field
                  v-model="formData.volume"
                  :label="
                    $t('fundBaseForm.volume.label', {
                      year: new Date().getFullYear(),
                    })
                  "
                  :rules="[(v) => !!v || $t('validation.required')]"
                  required
                  type="number"
                >
                  <template #prepend>
                    <v-tooltip bottom max-width="300">
                      <template #activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help</v-icon>
                      </template>
                      <span>{{ $t("fundBaseForm.volume.help") }}</span>
                    </v-tooltip>
                  </template>
                </v-text-field>

                <v-autocomplete
                  v-model="formData.currency"
                  :items="currencies"
                  :label="$t('fundBaseForm.currency.label')"
                  :rules="[(v) => !!v || $t('validation.required')]"
                >
                  <template #prepend>
                    <v-tooltip bottom max-width="300">
                      <template #activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help</v-icon>
                      </template>
                      <span>{{ $t("fundBaseForm.currency.help") }}</span>
                    </v-tooltip>
                  </template>
                </v-autocomplete>

                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template #activator="{ on }">
                    <v-text-field
                      v-model="formData.launchDate"
                      :label="$t('fundBaseForm.launchDate.label')"
                      :hint="$t('fundBaseForm.launchDate.hint')"
                      :rules="[(v) => !!v || $t('validation.required')]"
                      readonly
                      v-on="on"
                    >
                      <template #prepend>
                        <v-tooltip bottom max-width="300">
                          <template #activator="{ on }">
                            <v-icon color="primary" dark v-on="on">mdi-help</v-icon>
                          </template>
                          <span>{{ $t("fundBaseForm.launchDate.help") }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="formData.launchDate" no-title scrollable @input="menu = false" />
                </v-menu>

                <v-select
                  :items="languages"
                  :label="$t('fundBaseForm.language.label')"
                  :rules="[(v) => !!v || $t('validation.required')]"
                  v-model="formData.language"
                >
                  <template #prepend>
                    <v-tooltip bottom max-width="300">
                      <template #activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help</v-icon>
                      </template>
                      <span>{{ $t("fundBaseForm.language.help") }}</span>
                    </v-tooltip>
                  </template>
                </v-select>

                <v-select
                  v-model="formData.disclosure"
                  :items="disclosure"
                  :label="$t('fundBaseForm.disclosure.label')"
                  :rules="[(v) => !!v || $t('validation.required')]"
                >
                  <template #prepend>
                    <v-tooltip bottom max-width="300">
                      <template #activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help</v-icon>
                      </template>
                      <span>{{ $t("fundBaseForm.disclosure.help") }}</span>
                    </v-tooltip>
                  </template>
                </v-select>

                <v-textarea
                  v-model="formData.disclosureComment"
                  :label="$t('fundBaseForm.disclosureComment.label')"
                  :hint="$t('fundBaseForm.disclosureComment.hint')"
                  :rules="[(v) => !v || v.length < 1000 || $t('validation.tooLong')]"
                  counter="1000"
                  auto-grow
                >
                  <template #prepend>
                    <v-tooltip bottom max-width="300">
                      <template #activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help</v-icon>
                      </template>
                      <span>{{ $t("fundBaseForm.disclosureComment.help") }}</span>
                    </v-tooltip>
                  </template>
                </v-textarea>

                <v-textarea
                  :label="$t('fundBaseForm.thirdPartyComment.label')"
                  :hint="$t('fundBaseForm.thirdPartyComment.hint')"
                  v-model="formData.thirdPartyComment"
                  auto-grow
                >
                  <template #prepend>
                    <v-tooltip bottom max-width="300">
                      <template #activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help</v-icon>
                      </template>
                      <span>{{ $t("fundBaseForm.thirdPartyComment.help") }}</span>
                    </v-tooltip>
                  </template>
                </v-textarea>

                <v-textarea
                  :label="$t('fundBaseForm.comment.label')"
                  v-model="formData.comment"
                  counter="200"
                  :rules="[(v) => !v || v.length < 200 || $t('validation.tooLong')]"
                  auto-grow
                >
                  <template #prepend>
                    <v-tooltip bottom max-width="300">
                      <template #activator="{ on }">
                        <v-icon color="primary" dark v-on="on">mdi-help</v-icon>
                      </template>
                      <span>{{ $t("fundBaseForm.comment.help") }}</span>
                    </v-tooltip>
                  </template>
                </v-textarea>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-btn color="primary" @click="save" :loading="loading" :disabled="!valid" class="mr-2">
              {{ $t("action.save") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-form>
  </v-container>
</template>

<script>
import { pick, sortBy, prop } from "ramda";
import AuditFundBaseQuery from "@/gql/queries/AuditFundBaseQuery.gql";
import UpdateFundMutation from "@/gql/mutations/UpdateFundMutation.gql";
import tranches from "@fng/common/tranches";
import countries from "@fng/common/countries";
import fundTypes from "@fng/common/fundTypes";
import disclosure from "@fng/common/disclosure";
import currencies from "@fng/common/currencies";
import assetClasses from "@fng/common/assetClasses";
import generateSelectItems from "@/utils/generateSelectItems";
import investmentRegions from "@fng/common/investmentRegions";
import investmentApproaches from "@fng/common/investmentApproaches";
const languages = ["en", "de"];
const fields = [
  "name",
  "assetManagement",
  "fof",
  "assetClasses",
  "assetClassesComment",
  "assetManager",
  "dependance",
  "isins",
  "privateInvestors",
  "benchmark",
  "investmentApproaches",
  "fundType",
  "salesCountries",
  "investmentRegion",
  "investmentRegionComment",
  "volume",
  "currency",
  "launchDate",
  "tranches",
  "tranchesComment",
  "performanceFee",
  "rter",
  "disclosure",
  "language",
  "disclosureComment",
  "thirdPartyComment",
  "comment",
];

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      formData: null,
      fund: null,
      valid: false,
      loading: false,
      menu: false,
    };
  },
  apollo: {
    fund: {
      query: AuditFundBaseQuery,
      variables() {
        return { id: this.id };
      },
    },
  },
  watch: {
    fund(val) {
      this.formData = {
        ...pick(fields, val),
        launchDate: val.launchDate ? val.launchDate.substr(0, 10) : null,
      };
    },
  },
  methods: {
    async save() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      try {
        await this.$apollo.mutate({
          mutation: UpdateFundMutation,
          variables: {
            id: this.fund.id,
            input: {
              ...this.formData,
              volume: parseFloat(this.formData.volume),
            },
          },
        });
        this.$emit("saved");
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    assetClasses: generateSelectItems(assetClasses, "fund.assetClasses"),
    investmentApproaches: generateSelectItems(investmentApproaches, "fund.investmentApproaches"),
    fundTypes: generateSelectItems(fundTypes, "fund.fundTypes"),
    assetManagement: generateSelectItems([false, true], "fund.assetManagement"),
    fof: generateSelectItems([false, true], "fund.fof"),
    tranches: generateSelectItems(tranches, "fund.tranches"),
    disclosure() {
      return sortBy(prop("text"), generateSelectItems(disclosure, "disclosure").apply(this));
    },
    investmentRegions: generateSelectItems(investmentRegions, "fund.investmentRegions"),
    countries() {
      return sortBy(prop("text"), generateSelectItems(countries, "countries").apply(this));
    },
    currencies() {
      return sortBy(prop("text"), generateSelectItems(currencies, "currencies").apply(this));
    },
    languages() {
      return sortBy(prop("text"), generateSelectItems(languages, "languages").apply(this));
    },
  },
};
</script>
